/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Planet = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    viewBox="0 0 132 132"
    ref={ref}
    css={{
      color: "#F4F6F8",
      height: "132px",
      width: "132px",
    }}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle cx={66} cy={66} r={66} fill="currentColor" />
      <path
        fill="#CAD0D8"
        d="M88 107c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM26 91c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zm11-76c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137z"
      />
      <circle cx={74.5} cy={97.5} r={1.5} fill="#CAD0D8" />
      <circle cx={47.5} cy={105.5} r={1.5} fill="#CAD0D8" />
      <circle cx={110.5} cy={90.5} r={1.5} fill="#CAD0D8" />
      <circle cx={29.5} cy={48.5} r={1.5} fill="#CAD0D8" />
      <circle cx={108.5} cy={45.5} r={1.5} fill="#CAD0D8" />
      <circle cx={20.5} cy={72.5} r={1.5} fill="#CAD0D8" />
      <circle cx={102.5} cy={29.5} r={1.5} fill="#CAD0D8" />
      <circle cx={59.5} cy={7.5} r={1.5} fill="#CAD0D8" />
      <circle cx={55.5} cy={32.5} r={1.5} fill="#CAD0D8" />
      <g transform="translate(55 118)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(104 66)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(10 49)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(76 10)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <path
        fill="#74B0F4"
        d="M56.182 63.594a7.329 7.329 0 0 1-7.159 8.86 8.281 8.281 0 0 1-1.56-.208 19.104 19.104 0 0 1 .016-14.28l.005-.003a7.329 7.329 0 0 1 8.698 5.631z"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M53.042 79.845c-8.13-6.68-9.302-18.685-2.622-26.815 6.68-8.13 18.686-9.302 26.815-2.622a18.9 18.9 0 0 1 2.401 2.36m4.547 11.914c.244 10.52-8.083 19.245-18.602 19.489-.39.01-.78.006-1.17-.008"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M48.195 73.84c-3.779 5.89-5.244 10.634-3.404 12.476 3.187 3.187 15.068-3.53 26.538-14.999 11.47-11.468 18.193-23.35 14.999-26.536-1.835-1.834-6.602-.334-12.46 3.41"
      />
      <path
        fill="#F18686"
        d="M67.338 53.405A3.662 3.662 0 0 1 71 57.07a3.662 3.662 0 0 1-3.663 3.663 3.662 3.662 0 0 1-3.664-3.663 3.662 3.662 0 0 1 3.664-3.664z"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M67.338 53.405A3.662 3.662 0 0 1 71 57.07a3.662 3.662 0 0 1-3.663 3.663 3.662 3.662 0 0 1-3.664-3.663 3.662 3.662 0 0 1 3.664-3.664zm-19.854 4.558a7.329 7.329 0 0 1 8.698 5.631 7.329 7.329 0 0 1-7.159 8.86 8.282 8.282 0 0 1-1.563-.209"
      />
    </g>
  </svg>
));
